import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useMediaQuery } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MasonryGrid from "../MasonryGrid/MasonryGrid";


export default function CarouselRooms({ property }) {
  const [open, setOpen] = React.useState(false);
  const containerRef = React.useRef(null);

  const isTabletOrMobile = useMediaQuery("(max-width: 1024px)");

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <Box
      ref={containerRef}
      sx={{
        width: "100%",
        height: "100%",
        zIndex: 1000,
        marginTop: isTabletOrMobile ? 0 : 5,
        pointerEvents: "auto",
        display: "flex",
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          gap: 2,
          alignItems: "start",
          flexDirection: isTabletOrMobile ? "column" : "row",
        }}
      >
        <Box height={"100%"} width={"100%"}>
          <img
            src={property[0]}
            alt="Selected"
            onClick={handleOpen}
            style={{
              width: "100%",
              height: isTabletOrMobile ? "40vh" : "100%",
              cursor: "pointer",
              borderRadius: "8px",
              objectFit: "cover",
            }}
          />
        </Box>
        <Box
          sx={{
            width: "32.5%",
            height: "100%",
            display: "flex",
            flexDirection: isTabletOrMobile ? "row" : "column",
            gap: 1,
            position: "relative",
          }}
        >
          {property?.slice(1, 4).map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Thumbnail ${index}`}
              width={"100%"}
              height={isTabletOrMobile ? undefined : "32%"}
              onClick={handleOpen}
              style={{
                cursor: "pointer",
                borderRadius: "8px",
                objectFit: "cover",
              }}
            />
          ))}
          {property.length > 4 && (
            <Box
              sx={{
                position: "absolute",
                bottom: isTabletOrMobile ? undefined : 0,
                left: isTabletOrMobile ? undefined : 0,
                width: "100%",
                height: isTabletOrMobile ? "100%" : "33.5%",
                backgroundColor: "rgba(0, 0, 0, 0.14)",
                color: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "18px",
                borderRadius: "8px",
                cursor: "pointer",
                objectFit: "cover",
              }}
              onClick={handleOpen}
            >
              +{property.length - 4}
            </Box>
          )}
        </Box>
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            backgroundColor: "#fff",
            alignItems: "center",
            height: "100vh",
            overflowY: "scroll",
            paddingTop: 30,
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 15,
              left: 15,
              backgroundColor: "#c7d2d6",
            }}
          >
            <CloseIcon color="white" />
          </IconButton>
          <MasonryGrid photos={property} />
        </Box>
      </Modal>
    </Box>
  );
}
